module.exports = __webpack_public_path__ + "img/capability-slider-img-4.de2f0b72.png";